import { StyleSheet } from 'react-native';
import {
  defaultWidth,
  fontFamilyMedium,
  fontSizeMedium,
  italic,
} from '../../../constants/palette';

export default StyleSheet.create({
  buttonGroup: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: defaultWidth,
  },
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  image: { width: 250, height: 250 },
  stepStyle: {
    fontStyle: italic,
    fontSize: fontSizeMedium,
  },
  text: {
    fontFamily: fontFamilyMedium,
    fontSize: fontSizeMedium,
    marginTop: 20,
    width: defaultWidth,
  },
});
